(function () {
  function qs(sel, root){ return (root || document).querySelector(sel); }
  function qsa(sel, root){ return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  function moneyGBP(n){
    try { return new Intl.NumberFormat("en-GB",{style:"currency",currency:"GBP",maximumFractionDigits:0}).format(n); }
    catch(e){ return "£" + Math.round(n); }
  }

  function initCalc(root){
    const BOOK_DEMO_URL = "https://pages.fullswingemea.com/book-a-meeting-with-niall-request-kit?_gl=1*1dafzn9*_gcl_au*NDAyMTA3NTA4LjE3Njg5OTcxNjE.";
    const DEPOSIT_PRODUCT_URL = "https://fullswingemea.com/products/full-swing-simulator-deposit";
    const FOOTER_WEBSITE = "www.fullswingemea.com";

    const COUNTRIES = [
      "United Kingdom","Ireland","France","Germany","Spain","Portugal","Italy","Netherlands","Belgium","Switzerland","Austria",
      "Sweden","Norway","Denmark","Finland","Poland","Czech Republic","Slovakia","Hungary","Romania","Bulgaria","Greece","Turkey",
      "United States","Canada","Mexico","Brazil","Argentina","Chile","Colombia",
      "United Arab Emirates","Saudi Arabia","Qatar","Kuwait","Bahrain","Oman",
      "South Africa","Nigeria","Kenya","Egypt","Morocco",
      "India","Pakistan","Bangladesh","Sri Lanka",
      "China","Hong Kong","Japan","South Korea","Singapore","Malaysia","Thailand","Vietnam","Philippines","Indonesia",
      "Australia","New Zealand"
    ];

    const PREVIEW_IMAGES = {
      opening: "https://cdn.shopify.com/s/files/1/0903/0267/7372/files/builder_20.png?v=1771783116",

      sim_pro2_1: "https://cdn.shopify.com/s/files/1/0903/0267/7372/files/builder_5.png?v=1771783175",
      sim_pro2_2: "https://cdn.shopify.com/s/files/1/0903/0267/7372/files/builder_6.png?v=1771783174",

      sim_sports_1: "https://cdn.shopify.com/s/files/1/0903/0267/7372/files/builder_7.png?v=1771783226",
      sim_sports_2: "https://cdn.shopify.com/s/files/1/0903/0267/7372/files/builder_8.png?v=1771783225",

      /* Residential (4) */
      res_1: "https://cdn.shopify.com/s/files/1/0903/0267/7372/files/RESIDENTIAL_3.png?v=1772101751",
      res_2: "https://cdn.shopify.com/s/files/1/0903/0267/7372/files/RESIDENTIAL_2.png?v=1772101751",
      res_3: "https://cdn.shopify.com/s/files/1/0903/0267/7372/files/RESIDENTIAL_1.png?v=1772101750",
      res_4: "https://cdn.shopify.com/s/files/1/0903/0267/7372/files/RESIDENTIAL_4.png?v=1772101751",

      /* Commercial (3) */
      com_1: "https://cdn.shopify.com/s/files/1/0903/0267/7372/files/COMMERCIAL_5.png?v=1772101604",
      com_2: "https://cdn.shopify.com/s/files/1/0903/0267/7372/files/COMMERCIAL_3.png?v=1772101604",
      com_3: "https://cdn.shopify.com/s/files/1/0903/0267/7372/files/COMMERCIAL_1.png?v=1772101603",

      /* ✅ NEW: Widescreen (2) */
      wide_1: "https://cdn.shopify.com/s/files/1/0903/0267/7372/files/WIDESCREEN_FRONT.png?v=1772102861",
      wide_2: "https://cdn.shopify.com/s/files/1/0903/0267/7372/files/WIDESCREEN.png?v=1772102860",

      /* ✅ NEW: Standard (2) */
      std_1: "https://cdn.shopify.com/s/files/1/0903/0267/7372/files/STANDARD_SCREEN_FRONT.png?v=1772102860",
      std_2: "https://cdn.shopify.com/s/files/1/0903/0267/7372/files/STANDARD_SCREEN.png?v=1772102860",

      /* ✅ NEW: No dimensions / recommendations image */
      simulators_reco: "https://cdn.shopify.com/s/files/1/0903/0267/7372/files/SIMULATORS.png?v=1772103122",

      measurements: "https://cdn.shopify.com/s/files/1/0903/0267/7372/files/builder_16.png?v=1771783774",

      soft_golf: "https://cdn.shopify.com/s/files/1/0903/0267/7372/files/builder_17.png?v=1771783836",
      soft_games: "https://cdn.shopify.com/s/files/1/0903/0267/7372/files/builder_18.png?v=1771783839",

      country: "https://cdn.shopify.com/s/files/1/0903/0267/7372/files/builder_19.png?v=1771783906",
      quantity: "https://cdn.shopify.com/s/files/1/0903/0267/7372/files/builder_2.png?v=1771783983"
    };

    const PRESET_RANGES = {
      standard: { label:"Standard", h:{min:"8'6\"", max:"10'"},   w:{min:"11'",  max:"12'6\""}, d:{min:"18'6\"", max:"20'"} },
      widescreen:{label:"Widescreen",h:{min:"14'9\"",max:"16'6\""},w:{min:"9'",   max:"10'"},   d:{min:"20'6\"", max:"22'"} }
    };

    const SIM_PRICING = {
      pro2:   { standard: 52500, widescreen: 62500 },
      sports: { standard: 42500, widescreen: 47500 }
    };

    const SIM_MODELS = [
      { id:"pro2", name:"FULL SWING Pro 2.0 Simulator", priceFrom: 52500 },
      { id:"sports", name:"FULL SWING Sports Series Simulator", priceFrom: 42500 }
    ];

    const SOFTWARE = [
      { id:"golf",  name:"Full Swing Golf", price:999 },
      { id:"multi", name:"Full Swing Multisport & Games", price:799 },
      { id:"both",  name:"Both (Golf + Multisport & Games)", price:999+799 }
    ];

    const STEPS = [
      { id:"model",        title:"Simulator. Which is best for you?", required:true },
      { id:"timeline",     title:"Timeline. When are you looking to buy?", required:true },
      { id:"space_type",   title:"Space. Where will you use it?", required:true },
      { id:"screen",       title:"Screen. Standard or widescreen?", required:true },
      { id:"dims_confirm", title:"Measurements. Do you have dimensions?", required:true },
      { id:"dims",         title:"Room. Confirm the space", required:true },
      { id:"quantity",     title:"Quantity. How many simulators?", required:false },
      { id:"software",     title:"Software. What will you play?", required:true },
      { id:"shipping",     title:"Location. Where should we deliver?", required:true },
      { id:"extras",       title:"Extras. Add-on items (priced later)", required:false },
      { id:"review",       title:"Review. Your build summary", required:true }
    ];

    const state = {
      activeIndex: 0,
      simModel: null,
      timeline: "",
      spaceType: null,
      screen: null,
      dimsConfirmed: null,
      dims: { h:"", w:"", d:"" },
      simCount: 1,
      shipping: "",
      software: null,
      extras: { clubs:false, bag:false, balls:false, soundbar:false },
      previewContext: "model"
    };

    const els = {
      scroll: qs("#fsScroll", root),
      stepsWrap: qs("#fsSteps", root),

      galleryViewport: qs("#fsGalleryViewport", root),
      img1: qs("#fsImg1", root),
      img2: qs("#fsImg2", root),
      img3: qs("#fsImg3", root),
      img4: qs("#fsImg4", root),

      dotWrap: qs(".fs-gallery-dots", root),
      dotBtns: qsa(".fs-dotbtn", root),
      prevImg: qs("#fsPrevImg", root),
      nextImg: qs("#fsNextImg", root),

      estimateValue: qs("#fsEstimateValue", root),

      modal: qs("#fsModalBackdrop", root),
      modalClose: qs("#fsModalClose", root),
      modalCancel: qs("#fsCancelQuoteBtn", root),
      leadName: qs("#fsLeadName", root),
      leadSurname: qs("#fsLeadSurname", root),
      leadEmail: qs("#fsLeadEmail", root),
      leadErr: qs("#fsLeadError", root),
      genQuote: qs("#fsGenerateQuoteBtn", root)
    };

    function formatHeading(title){
      var str = String(title || "").trim();
      var dotIndex = str.indexOf(".");
      if (dotIndex === -1) return `<span class="fs-title-strong">${str}</span>`;
      var strong = str.slice(0, dotIndex).trim();
      var rest = str.slice(dotIndex + 1).trim();
      return `<span class="fs-title-strong">${strong}.</span><span class="fs-title-soft">${rest}</span>`;
    }

    function getUnitPrice(){
      if (!state.simModel || !state.screen) return null;
      var table = SIM_PRICING[state.simModel];
      return table ? table[state.screen] : null;
    }

    function getScreenRangeText(){
      if (!state.screen) return "";
      var r = PRESET_RANGES[state.screen];
      if (!r) return "";
      return `H ${r.h.min}–${r.h.max} · W ${r.w.min}–${r.w.max} · D ${r.d.min}–${r.d.max}`;
    }

    function summarizeDims(){
      if (state.dimsConfirmed === "yes"){
        var h = (state.dims.h || "").trim();
        var w = (state.dims.w || "").trim();
        var d = (state.dims.d || "").trim();
        if (h && w && d) return `${w}w × ${d}d × ${h}h`;
        return "";
      }
      if (state.dimsConfirmed === "no" && state.screen){
        var rr = PRESET_RANGES[state.screen];
        return rr ? `${rr.label}: ${getScreenRangeText()}` : "";
      }
      return "";
    }

    function timelineLabel(){
      var map = {
        ready: "Ready now (0–30 days)",
        "1_3": "1–3 months",
        "3_6": "3–6 months",
        "6_plus": "6+ months",
        research: "Just researching"
      };
      return map[state.timeline] || "—";
    }

    function extrasText(){
      var items = [];
      if (state.extras.clubs) items.push("TaylorMade golf clubs");
      if (state.extras.bag) items.push("TaylorMade golf bag");
      if (state.extras.balls) items.push("TaylorMade golf balls");
      if (state.extras.soundbar) items.push("Improved soundbar");
      return items.length ? (items.join(", ") + " (priced on final quote)") : "None";
    }

    function isQuantityRequired(){ return state.spaceType === "com"; }

    function isValid(stepId){
      if (stepId === "model") return !!state.simModel;
      if (stepId === "timeline") return !!(state.timeline || "").trim();
      if (stepId === "space_type") return !!state.spaceType;
      if (stepId === "screen") return !!state.screen;
      if (stepId === "dims_confirm") return (state.dimsConfirmed === "yes" || state.dimsConfirmed === "no");

      if (stepId === "dims"){
        if (state.dimsConfirmed === "yes"){
          return !!((state.dims.h||"").trim() && (state.dims.w||"").trim() && (state.dims.d||"").trim());
        }
        if (state.dimsConfirmed === "no"){
          return !!state.screen;
        }
        return false;
      }

      if (stepId === "quantity"){
        if (!isQuantityRequired()) return true;
        return Number(state.simCount) >= 1;
      }

      if (stepId === "software") return !!state.software;
      if (stepId === "shipping") return !!(state.shipping || "").trim();
      if (stepId === "extras") return true;

      if (stepId === "review"){
        return ["model","timeline","space_type","screen","dims_confirm","dims","quantity","software","shipping","extras"].every(isValid);
      }
      return true;
    }

    function maxUnlockedIndex(){
      var unlocked = 0;
      for (var i=0;i<STEPS.length;i++){
        var ok = true;
        for (var j=0;j<i;j++){
          if (!isValid(STEPS[j].id)){ ok = false; break; }
        }
        if (ok) unlocked = i;
        else break;
      }
      return unlocked;
    }

    function updateActiveUI(){
      var sections = qsa(".fs-step-section", root);
      var unlockedMax = maxUnlockedIndex();

      sections.forEach(function(sec){
        var idx = Number(sec.getAttribute("data-idx") || "0");
        var stepId = sec.getAttribute("data-step");

        if (stepId === "quantity" && !isQuantityRequired()){
          sec.style.display = "none";
        } else {
          sec.style.display = "";
        }

        if (idx > unlockedMax) sec.classList.add("disabled");
        else sec.classList.remove("disabled");

        if (idx === state.activeIndex) sec.classList.add("active");
        else sec.classList.remove("active");
      });
    }

    function updateEstimateUI(){
      if (!els.estimateValue) return;

      var qty = Number(isQuantityRequired() ? (state.simCount || 1) : 1);
      var unit = getUnitPrice();
      var model = SIM_MODELS.find(function(m){ return m.id === state.simModel; });

      var simEstimate = 0;
      var hasEstimate = false;

      if (unit){
        simEstimate = unit * qty;
        hasEstimate = true;
      } else if (model){
        simEstimate = model.priceFrom * qty;
        hasEstimate = true;
      }

      var soft = SOFTWARE.find(function(s){ return s.id === state.software; });
      var softEstimate = soft ? soft.price : 0;

      var total = (hasEstimate ? simEstimate : 0) + softEstimate;

      if (!hasEstimate && !soft){
        els.estimateValue.textContent = "—";
        return;
      }
      els.estimateValue.textContent = moneyGBP(total);
    }

    /* ---------- PREVIEW IMAGE CONTEXT ---------- */
    function getImagesForContext(ctx){
      if (ctx === "model" && !state.simModel) return [ PREVIEW_IMAGES.opening ];

      if (ctx === "model"){
        if (state.simModel === "pro2") return [ PREVIEW_IMAGES.sim_pro2_1, PREVIEW_IMAGES.sim_pro2_2 ];
        if (state.simModel === "sports") return [ PREVIEW_IMAGES.sim_sports_1, PREVIEW_IMAGES.sim_sports_2 ];
        return [ PREVIEW_IMAGES.opening ];
      }

      if (ctx === "timeline") return [ PREVIEW_IMAGES.opening ];

      if (ctx === "space_type"){
        if (state.spaceType === "res") return [ PREVIEW_IMAGES.res_1, PREVIEW_IMAGES.res_2, PREVIEW_IMAGES.res_3, PREVIEW_IMAGES.res_4 ];
        if (state.spaceType === "com") return [ PREVIEW_IMAGES.com_1, PREVIEW_IMAGES.com_2, PREVIEW_IMAGES.com_3, PREVIEW_IMAGES.com_4 ];
        return [ PREVIEW_IMAGES.opening ];
      }

      /* ✅ Screen now has 2 images each */
      if (ctx === "screen"){
        if (state.screen === "standard") return [ PREVIEW_IMAGES.std_1, PREVIEW_IMAGES.std_2 ];
        if (state.screen === "widescreen") return [ PREVIEW_IMAGES.wide_1, PREVIEW_IMAGES.wide_2 ];
        return [ PREVIEW_IMAGES.std_1 ];
      }

      /* ✅ Dims confirm "no" uses SIMULATORS.png */
      if (ctx === "dims_confirm"){
        if (state.dimsConfirmed === "no") return [ PREVIEW_IMAGES.simulators_reco ];
        return [ PREVIEW_IMAGES.measurements ];
      }

      if (ctx === "dims") return [ PREVIEW_IMAGES.measurements ];
      if (ctx === "quantity") return [ PREVIEW_IMAGES.quantity ];

      if (ctx === "software"){
        if (state.software === "golf") return [ PREVIEW_IMAGES.soft_golf ];
        if (state.software === "multi") return [ PREVIEW_IMAGES.soft_games ];
        if (state.software === "both") return [ PREVIEW_IMAGES.soft_golf ];
        return [ PREVIEW_IMAGES.soft_golf ];
      }

      if (ctx === "shipping") return [ PREVIEW_IMAGES.country ];
      if (ctx === "extras") return [ PREVIEW_IMAGES.opening ];

      return [ PREVIEW_IMAGES.opening ];
    }

    /* ---------- CAROUSEL (supports up to 4) ---------- */
    function setCarouselMode(count){
      var multi = count > 1;
      var slides = [els.img1, els.img2, els.img3, els.img4];

      slides.forEach(function(img, i){
        if (!img) return;
        img.closest(".fs-gallery-slide").style.display = (i < count ? "" : "none");
      });

      if (els.prevImg) els.prevImg.style.display = multi ? "flex" : "none";
      if (els.nextImg) els.nextImg.style.display = multi ? "flex" : "none";
      if (els.dotWrap) els.dotWrap.style.display = multi ? "flex" : "none";

      els.dotBtns.forEach(function(dot, i){
        dot.style.display = (i < count ? "" : "none");
      });
    }

    function setActiveDot(i){
      els.dotBtns.forEach(function(b, idx){
        b.classList.toggle("active", idx === i);
      });
    }

    function currentSlideIndex(maxCount){
      if (!els.galleryViewport) return 0;
      var w = els.galleryViewport.clientWidth || 1;
      var idx = Math.round(els.galleryViewport.scrollLeft / w);
      var last = Math.max(0, (maxCount || 1) - 1);
      if (idx < 0) idx = 0;
      if (idx > last) idx = last;
      return idx;
    }

    function updateArrowState(maxIdx){
      var idx = currentSlideIndex(maxIdx);
      var last = Math.max(0, (maxIdx || 1) - 1);

      if (els.prevImg){
        els.prevImg.style.opacity = (idx === 0 ? "0.35" : "1");
        els.prevImg.style.pointerEvents = (idx === 0 ? "none" : "auto");
      }
      if (els.nextImg){
        els.nextImg.style.opacity = (idx === last ? "0.35" : "1");
        els.nextImg.style.pointerEvents = (idx === last ? "none" : "auto");
      }
    }

    function slideTo(index){
      if (!els.galleryViewport) return;
      var w = els.galleryViewport.clientWidth || 1;
      els.galleryViewport.scrollTo({ left: index * w, behavior:"smooth" });
    }

    function slideBy(delta, maxCount){
      var idx = currentSlideIndex(maxCount);
      var last = Math.max(0, (maxCount || 1) - 1);
      var next = Math.max(0, Math.min(last, idx + delta));
      slideTo(next);
    }

    function setGallery(images){
      var imgs = [els.img1, els.img2, els.img3, els.img4];
      var count = Math.min(4, Math.max(1, images.length));

      setCarouselMode(count);

      for (var i=0;i<4;i++){
        if (!imgs[i]) continue;
        if (i < count){
          imgs[i].src = images[i];
          imgs[i].onerror = function(){ this.src = PREVIEW_IMAGES.opening; };
        } else {
          imgs[i].src = "";
        }
      }

      if (els.galleryViewport) els.galleryViewport.scrollLeft = 0;
      setActiveDot(0);
      updateArrowState(count);
    }

    function updatePreviewForContext(ctx){
      state.previewContext = ctx;
      setGallery(getImagesForContext(ctx));
    }

    function bumpActiveToNextUnlocked(){
      var unlockedMax = maxUnlockedIndex();
      if (state.activeIndex < unlockedMax) state.activeIndex = unlockedMax;
      updateActiveUI();
    }

    /* ---------- UI RENDER HELPERS ---------- */
    function cardBasic(opts){
      return `
        <button class="fs-card ${opts.selected ? "selected" : ""}" type="button" data-action="${opts.action}">
          <p class="fs-card-title">${opts.title}</p>
          ${opts.priceLine ? `<p class="fs-card-price">${opts.priceLine}</p>` : ""}
          ${opts.desc ? `<div class="fs-card-desc">${opts.desc}</div>` : ""}
        </button>
      `;
    }

    function pillRow(options, selectedId, name){
      return `
        <div class="fs-pillrow" role="group" aria-label="${name}">
          ${options.map(function(o){
            return `
              <button class="fs-pill ${selectedId===o.id ? "selected" : ""}" type="button" data-action="${o.action}">
                <span class="fs-dot"></span>${o.label}
              </button>
            `;
          }).join("")}
        </div>
      `;
    }

    function renderReview(){
      var model = SIM_MODELS.find(function(m){ return m.id === state.simModel; });
      var soft = SOFTWARE.find(function(s){ return s.id === state.software; });
      var unit = getUnitPrice();
      var qty = Number(state.simCount || 1);
      var usedQty = Number(isQuantityRequired() ? qty : 1);
      var subtotal = unit ? unit * usedQty : null;

      var rows = [
        ["Sim model", model ? model.name : "—"],
        ["Purchase timeline", timelineLabel()],
        ["Space type", state.spaceType === "res" ? "Residential" : "Commercial"],
        ["Screen format", state.screen === "standard" ? "Standard" : "Widescreen"],
        ["Measurements", state.dimsConfirmed === "yes" ? "Confirmed" : "Recommended ranges"],
        ["Room", summarizeDims() || "—"],
        ["Number of sims", String(usedQty)],
        ["Simulator price (unit)", unit ? moneyGBP(unit) : "—"],
        ["Simulator subtotal", subtotal ? moneyGBP(subtotal) : "—"],
        ["Shipping to", (state.shipping || "").trim() || "—"],
        ["Software (annual)", soft ? (soft.name + " (" + moneyGBP(soft.price) + "/yr)") : "—"],
        ["Extras", extrasText()],
        ["Notes", "Plus VAT and Shipping / Installation"]
      ];

      return `
        <div class="fs-callout">
          <strong>Your build summary</strong>
          Review your selections below. Next, you can pay a £1,000 deposit, book a demo, or download your quote.
        </div>

        <div style="margin-top:14px;border:1px solid rgba(0,0,0,.10);border-radius:16px;overflow:hidden;background:#fff;">
          ${rows.map(function(r){
            return `
              <div style="display:flex;justify-content:space-between;gap:12px;padding:12px 14px;border-bottom:1px solid rgba(0,0,0,.06);">
                <div style="opacity:.7;font-weight:950;">${r[0]}</div>
                <div style="font-weight:950;text-align:right;">${r[1]}</div>
              </div>
            `;
          }).join("")}
        </div>

        <div class="fs-callout" style="margin-top:14px;">
          <strong>Deposit</strong>
          Deposit is fixed at <b>£1,000</b> and applied to your final purchase.
        </div>

        <div style="margin-top:14px;display:grid;gap:10px;">
          <a class="fs-btn primary full fs-btn-link" href="${DEPOSIT_PRODUCT_URL}">Pay £1,000 deposit</a>
          <a class="fs-btn black full fs-btn-link" href="${BOOK_DEMO_URL}">Book a demo</a>
          <button class="fs-btn ghost full" type="button" data-action="download:open">Download your custom sim quote</button>
          <button class="fs-btn ghost full" type="button" data-action="reset:all" style="border-color:rgba(0,0,0,.22);">Start again</button>
          <div style="text-align:center;opacity:.7;font-size:12px;line-height:1.35;margin-top:4px;">
            Prices shown exclude VAT and Shipping / Installation. Final pricing confirmed after consultation/site fit.
          </div>
        </div>
      `;
    }

    function renderStepSection(stepId){
      var meta = STEPS.find(function(s){ return s.id === stepId; });
      var title = meta ? meta.title : "";
      var body = "";

      if (stepId === "model"){
        body = `
          <div class="fs-cards stack">
            ${SIM_MODELS.map(function(m){
              return cardBasic({
                selected: state.simModel === m.id,
                title: m.name,
                priceLine: "From " + moneyGBP(m.priceFrom) + " · plus VAT & shipping/installation",
                desc: "",
                action: "model:" + m.id
              });
            }).join("")}
          </div>
        `;
      }

      if (stepId === "timeline"){
        body = `
          <div class="fs-form">
            <div class="fs-field full">
              <label>Purchase timeline</label>
              <select data-bind="timeline">
                <option value="" ${!state.timeline ? "selected" : ""} disabled>Select a timeline</option>
                <option value="ready" ${state.timeline==="ready" ? "selected" : ""}>Ready now (0–30 days)</option>
                <option value="1_3" ${state.timeline==="1_3" ? "selected" : ""}>1–3 months</option>
                <option value="3_6" ${state.timeline==="3_6" ? "selected" : ""}>3–6 months</option>
                <option value="6_plus" ${state.timeline==="6_plus" ? "selected" : ""}>6+ months</option>
                <option value="research" ${state.timeline==="research" ? "selected" : ""}>Just researching</option>
              </select>
            </div>
          </div>
        `;
      }

      if (stepId === "space_type"){
        body = pillRow([
          { id:"res", label:"Residential", action:"space_type:res" },
          { id:"com", label:"Commercial", action:"space_type:com" }
        ], state.spaceType, "Space type");
      }

      if (stepId === "screen"){
        body = `
          <div class="fs-cards stack">
            ${cardBasic({ selected: state.screen === "standard", title: "Standard screen", action: "screen:standard" })}
            ${cardBasic({ selected: state.screen === "widescreen", title: "Widescreen", action: "screen:widescreen" })}
          </div>
        `;
      }

      if (stepId === "dims_confirm"){
        body = `
          <div class="fs-cards stack">
            ${cardBasic({ selected: state.dimsConfirmed === "yes", title: "Yes, I have dimensions", desc: "Enter your room size to confirm fit.", action: "dims_confirm:yes" })}
            ${cardBasic({ selected: state.dimsConfirmed === "no", title: "No, show me recommended ranges", desc: "We’ll estimate requirements based on your screen format.", action: "dims_confirm:no" })}
          </div>
        `;
      }

      if (stepId === "dims"){
        if (state.dimsConfirmed === "yes"){
          body = `
            <div class="fs-form">
              <div class="fs-field"><label>Ceiling height</label><input data-bind="h" type="text" placeholder="e.g. 9ft / 2.75m" value="${state.dims.h || ""}"></div>
              <div class="fs-field"><label>Room width</label><input data-bind="w" type="text" placeholder="e.g. 12ft / 3.6m" value="${state.dims.w || ""}"></div>
              <div class="fs-field"><label>Room depth</label><input data-bind="d" type="text" placeholder="e.g. 20ft / 6.1m" value="${state.dims.d || ""}"></div>
            </div>
          `;
        } else {
          var info = state.screen ? getScreenRangeText() : "";
          body = `
            <div class="fs-callout">
              <strong>Recommended range (${state.screen === "widescreen" ? "Widescreen" : "Standard"})</strong>
              ${info || "Select a screen format above to view recommended ranges."}
            </div>
          `;
        }
      }

      if (stepId === "quantity"){
        body = `
          <div class="fs-form">
            <div class="fs-field full">
              <label>Number of sims</label>
              <select data-bind="count">
                ${[1,2,3,4,5,6,7,8,9,10].map(function(n){
                  return `<option value="${n}" ${Number(state.simCount)===n ? "selected" : ""}>${n}</option>`;
                }).join("")}
              </select>
            </div>
          </div>
        `;
      }

      if (stepId === "software"){
        body = `
          <div class="fs-cards stack">
            ${SOFTWARE.map(function(s){
              return cardBasic({
                selected: state.software === s.id,
                title: s.name,
                priceLine: moneyGBP(s.price) + "/yr",
                action: "software:" + s.id
              });
            }).join("")}
          </div>
        `;
      }

      if (stepId === "shipping"){
        body = `
          <div class="fs-form">
            <div class="fs-field full">
              <label>Delivery country</label>
              <select data-bind="ship">
                <option value="" ${!state.shipping ? "selected" : ""} disabled>Select a country</option>
                ${COUNTRIES.map(function(c){
                  return `<option value="${c}" ${state.shipping===c ? "selected" : ""}>${c}</option>`;
                }).join("")}
              </select>
            </div>
          </div>
        `;
      }

      if (stepId === "extras"){
        body = `
          <div class="fs-callout">
            <strong>Add extras to your quote</strong>
            Pricing will be provided in your final quote once discussed with the sales team.
          </div>

          <div class="fs-checklist">
            ${[
              ["clubs","TaylorMade golf clubs"],
              ["bag","TaylorMade golf bag"],
              ["balls","TaylorMade golf balls"],
              ["soundbar","Improved soundbar"]
            ].map(function(item){
              var key = item[0];
              var label = item[1];
              var checked = state.extras[key] ? "checked" : "";
              return `
                <label class="fs-checkitem">
                  <input type="checkbox" data-bind="extra" data-extra="${key}" ${checked}/>
                  <span class="fs-checktext">
                    <span class="fs-checktitle">${label}</span>
                    <span class="fs-checkmeta">Price on final quote</span>
                  </span>
                </label>
              `;
            }).join("")}
          </div>
        `;
      }

      if (stepId === "review"){
        body = renderReview();
      }

      var idx = STEPS.findIndex(function(s){ return s.id === stepId; });
      return `
        <section class="fs-step-section" data-step="${stepId}" data-idx="${idx}">
          <h3 class="fs-step-title">${formatHeading(title)}</h3>
          ${body}
        </section>
      `;
    }

    function renderAllStepsPreserveScroll(){
      var st = els.scroll ? els.scroll.scrollTop : 0;
      els.stepsWrap.innerHTML = STEPS.map(function(s){ return renderStepSection(s.id); }).join("");
      if (els.scroll) els.scroll.scrollTop = st;

      bindIntersectionObserver();
      updateActiveUI();
      updateEstimateUI();
    }

    function bindIntersectionObserver(){
      var sections = qsa(".fs-step-section", root);
      if (!sections.length || !els.scroll) return;

      if (bindIntersectionObserver._obs){
        try { bindIntersectionObserver._obs.disconnect(); } catch(e){}
      }

      var obs = new IntersectionObserver(function(entries){
        var best = null;
        entries.forEach(function(e){
          if (!e.isIntersecting) return;
          if (!best || e.intersectionRatio > best.intersectionRatio) best = e;
        });
        if (best){
          var idx = Number(best.target.getAttribute("data-idx") || "0");
          if (!Number.isNaN(idx)){
            state.activeIndex = idx;
            updateActiveUI();
          }
        }
      }, { root: els.scroll, threshold:[0.35,0.5,0.65,0.8] });

      sections.forEach(function(sec){ obs.observe(sec); });
      bindIntersectionObserver._obs = obs;
    }

    function allRequiredValid(){
      return ["model","timeline","space_type","screen","dims_confirm","dims","quantity","software","shipping","extras","review"].every(isValid);
    }

    function validateEmail(email){ return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email); }

    function openModal(){
      if (els.leadErr) els.leadErr.textContent = "";
      els.modal.style.display = "flex";
      els.modal.setAttribute("aria-hidden", "false");
    }
    function closeModal(){
      els.modal.style.display = "none";
      els.modal.setAttribute("aria-hidden", "true");
    }

    function downloadQuote(){
      if (els.leadErr) els.leadErr.textContent = "";
      if (!allRequiredValid()){
        if (els.leadErr) els.leadErr.textContent = "Please complete the required sections first.";
        return;
      }

      var first = (els.leadName.value || "").trim();
      var last  = (els.leadSurname.value || "").trim();
      var email = (els.leadEmail.value || "").trim();

      if (!first || !last || !email){
        if (els.leadErr) els.leadErr.textContent = "Please complete Name, Surname, and Email.";
        return;
      }
      if (!validateEmail(email)){
        if (els.leadErr) els.leadErr.textContent = "Please enter a valid email address.";
        return;
      }

      var model = SIM_MODELS.find(function(m){ return m.id === state.simModel; });
      var soft = SOFTWARE.find(function(s){ return s.id === state.software; });
      var unit = getUnitPrice();
      var qty = Number(isQuantityRequired() ? (state.simCount || 1) : 1);
      var subtotal = unit ? unit * qty : null;

      var rows = [
        ["Sim model", model ? model.name : "—"],
        ["Purchase timeline", timelineLabel()],
        ["Space type", state.spaceType === "res" ? "Residential" : "Commercial"],
        ["Screen format", state.screen === "standard" ? "Standard" : "Widescreen"],
        ["Measurements", state.dimsConfirmed === "yes" ? "Confirmed" : "Recommended ranges"],
        ["Room", summarizeDims() || "—"],
        ["Number of sims", String(qty)],
        ["Simulator price (unit)", unit ? moneyGBP(unit) : "—"],
        ["Simulator subtotal", subtotal ? moneyGBP(subtotal) : "—"],
        ["Shipping to", (state.shipping || "").trim() || "—"],
        ["Software (annual)", soft ? (soft.name + " (" + moneyGBP(soft.price) + "/yr)") : "—"],
        ["Extras", extrasText()],
        ["Notes", "Plus VAT and Shipping / Installation"]
      ];

      var now = new Date();
      var ref = "FS-" + now.getFullYear() + (now.getMonth()+1) + now.getDate() + "-" + Math.floor(Math.random()*9000 + 1000);

      var html = `
        <html>
        <head>
          <meta charset="utf-8" />
          <title>Full Swing Quote Summary - ${ref}</title>
          <style>
            body{font-family:Arial,sans-serif;padding:24px;color:#111}
            .brand{display:flex;justify-content:space-between;gap:16px;align-items:flex-start}
            h1{margin:0;font-size:22px}
            .meta{margin-top:6px;opacity:.75;font-size:12px}
            .box{margin-top:16px;border:1px solid #ddd;border-radius:12px;padding:14px}
            .row{display:flex;justify-content:space-between;gap:12px;border-bottom:1px solid #eee;padding:10px 0}
            .row:last-child{border-bottom:none}
            .k{font-weight:700;opacity:.75}
            .v{font-weight:800;text-align:right}
            .callout{margin-top:16px;background:#eef3ff;border:1px solid #c9d7ff;border-radius:12px;padding:14px}
            .deposit{font-weight:900}
            .cta{margin-top:14px;font-size:12px;opacity:.75}
            .footer{margin-top:18px;padding-top:12px;border-top:1px solid #eee;font-size:12px;opacity:.75;text-align:center}
          </style>
        </head>
        <body>
          <div class="brand">
            <div>
              <h1>Full Swing — Quote Summary</h1>
              <div class="meta">Reference: <strong>${ref}</strong> · Generated: ${now.toLocaleString()}</div>
            </div>
            <div class="meta" style="text-align:right;">
              Prepared for<br><strong>${first} ${last}</strong><br>${email}
            </div>
          </div>

          <div class="box">
            ${rows.map(function(r){
              return `<div class="row"><span class="k">${r[0]}</span><span class="v">${r[1] || ""}</span></div>`;
            }).join("")}
          </div>

          <div class="callout">
            <div class="deposit">Deposit: £1,000</div>
            <div class="cta">Deposit is fixed and applied to your final purchase. Final pricing confirmed after consultation/site fit.</div>
          </div>

          <div class="footer">${FOOTER_WEBSITE}</div>
          <script>window.onload=function(){window.print();}<\/script>
        </body>
        </html>
      `;

      var w = window.open("", "_blank");
      if (!w){
        if (els.leadErr) els.leadErr.textContent = "Popup blocked. Please allow popups to download your quote.";
        return;
      }
      w.document.open();
      w.document.write(html);
      w.document.close();
      closeModal();
    }

    function resetAll(){
      state.activeIndex = 0;
      state.simModel = null;
      state.timeline = "";
      state.spaceType = null;
      state.screen = null;
      state.dimsConfirmed = null;
      state.dims = {h:"",w:"",d:""};
      state.simCount = 1;
      state.shipping = "";
      state.software = null;
      state.extras = { clubs:false, bag:false, balls:false, soundbar:false };
      state.previewContext = "model";

      renderAllStepsPreserveScroll();
      state.activeIndex = 0;
      updateActiveUI();
      updatePreviewForContext("model");
      updateEstimateUI();
    }

    /* ---------- EVENTS ---------- */
    root.addEventListener("click", function(e){
      var btn = e.target.closest("[data-action]");
      if (!btn) return;

      var action = btn.getAttribute("data-action") || "";
      var parts = action.split(":");
      var type = parts[0];
      var val = parts[1];

      if (type === "model"){
        state.simModel = val;
        renderAllStepsPreserveScroll();
        updatePreviewForContext("model");
        bumpActiveToNextUnlocked();
        updateEstimateUI();
        return;
      }

      if (type === "space_type"){
        state.spaceType = val;
        if (!isQuantityRequired()) state.simCount = 1;
        renderAllStepsPreserveScroll();
        updatePreviewForContext("space_type");
        bumpActiveToNextUnlocked();
        updateEstimateUI();
        return;
      }

      if (type === "screen"){
        state.screen = val;
        renderAllStepsPreserveScroll();
        updatePreviewForContext("screen");
        bumpActiveToNextUnlocked();
        updateEstimateUI();
        return;
      }

      if (type === "dims_confirm"){
        state.dimsConfirmed = val;
        if (val === "no") state.dims = {h:"",w:"",d:""};
        renderAllStepsPreserveScroll();
        updatePreviewForContext("dims_confirm");
        bumpActiveToNextUnlocked();
        updateEstimateUI();
        return;
      }

      if (type === "software"){
        state.software = val;
        renderAllStepsPreserveScroll();
        updatePreviewForContext("software");
        bumpActiveToNextUnlocked();
        updateEstimateUI();
        return;
      }

      if (type === "download" && val === "open"){
        if (!allRequiredValid()) return;
        openModal();
        return;
      }

      if (type === "reset" && val === "all"){
        resetAll();
        return;
      }
    });

    root.addEventListener("input", function(e){
      var el = e.target;
      if (!el) return;

      var bind = el.getAttribute("data-bind");
      if (bind === "h"){ state.dims.h = el.value; updatePreviewForContext("dims"); bumpActiveToNextUnlocked(); return; }
      if (bind === "w"){ state.dims.w = el.value; updatePreviewForContext("dims"); bumpActiveToNextUnlocked(); return; }
      if (bind === "d"){ state.dims.d = el.value; updatePreviewForContext("dims"); bumpActiveToNextUnlocked(); return; }
    });

    root.addEventListener("change", function(e){
      var el = e.target;
      if (!el) return;

      var bind = el.getAttribute("data-bind");

      if (bind === "timeline"){
        state.timeline = el.value || "";
        renderAllStepsPreserveScroll();
        updatePreviewForContext("timeline");
        bumpActiveToNextUnlocked();
        return;
      }

      if (bind === "count"){
        state.simCount = Number(el.value || 1);
        updatePreviewForContext("quantity");
        bumpActiveToNextUnlocked();
        updateEstimateUI();
        return;
      }

      if (bind === "ship"){
        state.shipping = el.value || "";
        updatePreviewForContext("shipping");
        bumpActiveToNextUnlocked();
        renderAllStepsPreserveScroll();
        updateEstimateUI();
        return;
      }

      if (bind === "extra"){
        var key = el.getAttribute("data-extra");
        if (key && state.extras && Object.prototype.hasOwnProperty.call(state.extras, key)){
          state.extras[key] = !!el.checked;
          renderAllStepsPreserveScroll();
          bumpActiveToNextUnlocked();
        }
        return;
      }
    });

    /* Carousel bindings */
    if (els.dotBtns.length && els.galleryViewport){
      els.dotBtns.forEach(function(btn){
        btn.addEventListener("click", function(){
          var idx = Number(btn.getAttribute("data-dot") || "0");
          slideTo(idx);
        });
      });

      els.galleryViewport.addEventListener("scroll", function(){
        var imgs = getImagesForContext(state.previewContext);
        var idx = currentSlideIndex(imgs.length);
        setActiveDot(idx);
        updateArrowState(imgs.length);
      }, {passive:true});

      window.addEventListener("resize", function(){
        var imgs = getImagesForContext(state.previewContext);
        var idx = currentSlideIndex(imgs.length);
        setActiveDot(idx);
        updateArrowState(imgs.length);
      });
    }

    if (els.prevImg) els.prevImg.addEventListener("click", function(){
      var imgs = getImagesForContext(state.previewContext);
      slideBy(-1, imgs.length);
    });

    if (els.nextImg) els.nextImg.addEventListener("click", function(){
      var imgs = getImagesForContext(state.previewContext);
      slideBy(1, imgs.length);
    });

    if (els.modalClose) els.modalClose.addEventListener("click", closeModal);
    if (els.modalCancel) els.modalCancel.addEventListener("click", closeModal);
    if (els.modal) els.modal.addEventListener("click", function(ev){ if (ev.target === els.modal) closeModal(); });
    if (els.genQuote) els.genQuote.addEventListener("click", downloadQuote);

    /* Init */
    renderAllStepsPreserveScroll();
    bindIntersectionObserver();
    updateActiveUI();
    updatePreviewForContext("model");
    updateEstimateUI();
  }

  function boot(){
    qsa('[data-fs-customizer]').forEach(initCalc);
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot);
  else boot();
})();